import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.myautoiqSegmentSettingsComponentState || initialState;

export const selectMyautoiqSegmentSettings = createSelector(
  [selectDomain],
  state => state.myautoiqSegmentSettings,
);
